module.exports = __webpack_public_path__ + "img/greece.9107178c.svg";